import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import UnloadModal from '@/pages/home/pages/home/Explore/components/UnloadModal';
import { CONTACT_EMAIL } from '@op/constants';

export default function CommonTips({
  wholeGameInfo,
  hasMargin = false,
}: {
  wholeGameInfo: any;
  hasMargin?: boolean;
}) {
  const [showTips, setShowTips] = useState(false);
  const { formatMessage } = useIntl();
  useEffect(() => {
    setShowTips(wholeGameInfo?.show_warn);
  }, [wholeGameInfo]);

  const [open, setOpen] = useState(false);
  const switchFeedbackWindows = () => {
    setOpen(!open);
  };

  return showTips ? (
    <>
      <Alert
        className={`common-tips-wrapper ${hasMargin ? 'has-margin' : ''}`}
        visible={showTips}
        hideIcon
        onClose={() => setShowTips(false)}
      >
        {formatMessage(
          {
            id: 'The game《{gameName}》has not been visited for a while, so data updates have been stopped to save resources. If you need to view the latest data, please contact {email} or submit your requirements in the "{feedback}" section at the top right of the navigation bar.',
          },
          {
            gameName: wholeGameInfo.entity_name,
            email: CONTACT_EMAIL,
            feedback: (
              <Button type="link" onClick={switchFeedbackWindows}>
                {formatMessage({ id: 'feedback' })}
              </Button>
            ),
          },
        )}
      </Alert>
      <UnloadModal visible={open} close={switchFeedbackWindows} />
    </>
  ) : null;
}
